import styled from "styled-components";

export const Wrapper = styled.div``;

export const Messages = styled.div`
    display: block;
    height: 200px;
    overflow-y: scroll;
    margin: 6px;
`;
